
import Icon from "../Icon/Icon";
import { Modal, Button ,Row, Col} from "react-bootstrap";
import { useEffect, useState , useContext} from "react";
import toTimeOnly from "../../utilities/toTimeOnly";
import toDateOnly from "../../utilities/toDateOnly";
import DatePicker from "../Form/DatePicker";
import TimePicker from "../Form/TimePicker";
import { Form } from "react-bootstrap";
import { Alert } from "react-bootstrap";
import { useApiClient } from "../../ApiService/useApiClient";
import { AppContext } from "../../context/AppContext";



const JobsheetCarerCheckInOut = ({agent,taskId,clientName, taskstarttime, taskendtime}) => {

    const api = useApiClient()
    const { user, SiteConfig } = useContext(AppContext);

    const [CheckedInData, setCheckedInData] = useState(null);
    const [error, setError] = useState(null);
    const [previewModal, setpreviewModal] = useState(false); 
    const [checkoutpreviewModal, setcheckoutpreviewModal] = useState(false); 
    const [currentDate, setcurrentDate] = useState(new Date().toISOString());

    const formDefault = {};
    const [formModal, setFormModal] = useState(formDefault);
    const [formOutModal, setFormOutModal] = useState(formDefault);

    const [CurrentPosLatitude, setCurrentPosLatitudel] = useState("");
    const [CurrentPosLongitude, setCurrentPosLongitude] = useState("");

    useEffect(()=>{

        const baseURL = "HMCareTask/getassignment/"+taskId+"/"+agent.agentId;
      
        api.get(baseURL)        
            .then((Response)=>{
                setCheckedInData(Response.data);
                console.log(Response.data)
            }).catch(error => {
                setError(error);     
                //console.log({error})
            });  


    },[])
    

    const isTaskEnded = () => {
        
        //Client level config check
        // if(SiteConfig.CURRENT_TENANT_EARLY_CHECKOUT_ALLOWED.toString().toLower() == "yes" || SiteConfig.CURRENT_TENANT_EARLY_CHECKOUT_ALLOWED.toString().toLower() == "1") return true;
        if (
  SiteConfig.CURRENT_TENANT_EARLY_CHECKOUT_ALLOWED.toString().toLowerCase() === "yes" || 
  SiteConfig.CURRENT_TENANT_EARLY_CHECKOUT_ALLOWED.toString() === "1"
) {
  return true;
}


        //If not early checkout allowed, the check for the time
        const now = new Date();
        const taskEnd = new Date(taskendtime);
        return now >= taskEnd;
        };


    function CheckInClick(){
       // alert("asdaddadsd");
        
       navigator.geolocation.getCurrentPosition(function(position) {
        //    console.log("Latitude is :", position.coords.latitude);
        //   console.log("Longitude is :", position.coords.longitude);

            setCurrentPosLatitudel(position.coords.latitude);
            setCurrentPosLongitude(position.coords.longitude);    

          });

        setpreviewModal(true)    
    }

    function closePreviewModal(){
        setpreviewModal(false)    
    }

    function CheckOutClick(){
       // alert("asdaddadsd");

       navigator.geolocation.getCurrentPosition(function(position) {
        //    console.log("Latitude is :", position.coords.latitude);
        //   console.log("Longitude is :", position.coords.longitude);

            setCurrentPosLatitudel(position.coords.latitude);
            setCurrentPosLongitude(position.coords.longitude);    

          });


       setcheckoutpreviewModal(true)    
    }

    function closecheckoutpreviewModal(){
        setcheckoutpreviewModal(false)    
    }

    function SubmitCheckIn(event){

        event.preventDefault();       
        
        let checkinDate = formModal.current.querySelector('#checkinDate').value; 
        let checkinTime = formModal.current.querySelector('#checkinTime').value; 

        const frmFormData = new FormData();
        frmFormData.append("TaskId", taskId)
        frmFormData.append("AgentId", agent.agentId)
        frmFormData.append("CheckInDateTime", checkinDate + (checkinTime ? 'T' + checkinTime + 'Z' : ''))
        frmFormData.append("CheckInLocation", CurrentPosLatitude.toString() +','+ CurrentPosLongitude.toString())

        //console.log(frmFormData);
        
        const sURL = "HMCareTask/carercheckin/";
       
        api.post(sURL,frmFormData)
        .then((Response)=>{            
            //console.log(Response.data)
            //setMedUpdated(true);
            setCheckedInData(Response.data);
        }).catch(error => {
            setError(error);     
            //console.log({error})
        });
          
        closePreviewModal()
        
    }

    function SubmitCheckOut(event){

        event.preventDefault();    
        
        // console.log(formOutModal)
        
        let checkoutDate = formOutModal.current.querySelector('#checkOutDate').value; 
        let checkoutTime = formOutModal.current.querySelector('#checkOutTime').value; 
        let completion_option_1 = (formOutModal.current.querySelector('#completion_option_1').checked ? formOutModal.current.querySelector('#completion_option_1').value : ""); 
        let completion_option_2 = (formOutModal.current.querySelector('#completion_option_2').checked ? formOutModal.current.querySelector('#completion_option_2').value : ""); 
        let completion_option_3 = (formOutModal.current.querySelector('#completion_option_3').checked ? formOutModal.current.querySelector('#completion_option_3').value : ""); 
        let completion_option_4 = (formOutModal.current.querySelector('#completion_option_4').checked ? formOutModal.current.querySelector('#completion_option_4').value : ""); 
        let completion_option_5 = (formOutModal.current.querySelector('#completion_option_5').checked ? formOutModal.current.querySelector('#completion_option_5').value : ""); 
        let completion_option_6 = (formOutModal.current.querySelector('#completion_option_6').checked ? formOutModal.current.querySelector('#completion_option_6').value : ""); 
        let completion_notes = formOutModal.current.querySelector('#completion_notes').value; 

        let completion_option = ""
        if(completion_option_1 != "") completion_option = completion_option +','+completion_option_1 ;
        if(completion_option_2 != "") completion_option = completion_option +','+completion_option_2 ;
        if(completion_option_3 != "") completion_option = completion_option +','+completion_option_3 ;
        if(completion_option_4 != "") completion_option = completion_option +','+completion_option_4 ;
        if(completion_option_5 != "") completion_option = completion_option +','+completion_option_5 ;
        if(completion_option_6 != "") completion_option = completion_option +','+completion_option_6 ;


        const frmFormData = new FormData();
        frmFormData.append("TaskId", taskId)
        frmFormData.append("AgentId", agent.agentId)
        frmFormData.append("CheckOutDateTime", checkoutDate + (checkoutTime ? 'T' + checkoutTime + 'Z' : ''))
        frmFormData.append("completion_notes", completion_notes)
        frmFormData.append("completion_option", completion_option)
        frmFormData.append("completion_datetime", checkoutDate + (checkoutTime ? 'T' + checkoutTime + 'Z' : ''))
        frmFormData.append("checkOutLocation", CurrentPosLatitude.toString() +','+ CurrentPosLongitude.toString())
        // console.log(
        //     completion_option 
        //     );
        
// return null

        const sURL = "HMCareTask/carercheckout/";
        
        api.post(sURL,frmFormData)
        .then((Response)=>{            
            //console.log(Response.data)
            //setMedUpdated(true);
            setCheckedInData(Response.data);
        }).catch(error => {
            setError(error);     
            //console.log({error})
        });
          
        closecheckoutpreviewModal()    

    }

    {error && 
        <Alert variant="danger">{error}</Alert>}

  return (
    <>
    <span style={{marginLeft:"20px"}}>


        {CheckedInData && CheckedInData.checkOutTime != null &&
        <>
        <span>
            <br></br>
            <em style={{color:"green", fontSize:"10pt"}}>Checked In on <b>{toDateOnly(CheckedInData.checkInTime) }</b> at <b>{toTimeOnly(CheckedInData.checkInTime)}</b></em>
            <br></br>
            <em style={{color:"green",fontSize:"10pt"}}>Checked Out on <b>{toDateOnly(CheckedInData.checkOutTime) }</b> at <b>{toTimeOnly(CheckedInData.checkOutTime)}</b></em>
        </span>
        </>
        }

        {CheckedInData && CheckedInData.checkInTime != null && CheckedInData.checkOutTime == null &&
        <>
        <span><p style={{color:"red",}}><em>Checked In on <b>{toDateOnly(CheckedInData.checkInTime) }</b> at <b>{toTimeOnly(CheckedInData.checkInTime)}</b></em></p></span>
        <span>
        {/* <Button className="btn-block" variant="success" onClick={CheckOutClick}>                                                
            <span>Check Out & Complete</span>
            <Icon name="signout"></Icon>
        </Button>  */}
        {isTaskEnded() ? (
            <Button className="btn-block" variant="success" onClick={CheckOutClick}>                                                
                <span>Check Out & Complete</span>
                <Icon name="signout"></Icon>
            </Button>
            ) : (
            <Alert variant="warning" className="mt-2">
                You can only check out after <strong>{toTimeOnly(taskendtime)}</strong>
            </Alert>
            )}

        </span>
        </>
        }
        
        {(!CheckedInData || CheckedInData.checkInTime == null ) &&
        <Button className="btn-block" variant="success" onClick={CheckInClick} >                                                
            <span>Check In</span>
            <Icon name="signin"></Icon>
        </Button> 
        }

    </span> 


    <Modal show={previewModal}>    
            <Form ref={formModal} onSubmit={SubmitCheckIn}>
                <Modal.Header>
                    <Modal.Title className="event-title" as="h4">Check In</Modal.Title>
                    <Modal.Title className="event-title" as="h6">{agent.name} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Row className="g-4">

                            <Col xs="12">
                                <h6 className="overline-title">Check In Date & Time</h6>                        
                            </Col>                   
                            
                            <Col xs="4">                        
                                <DatePicker id="checkinDate" name="checkinDate" value={currentDate} placeholder="yyyy-mm-dd" />                        
                            </Col>
                            
                            <Col xs="3">                                                
                                <TimePicker id="checkinTime" name="checkinTime" value={toTimeOnly(currentDate)} placeholder="hh:mm"/>                    
                            </Col>                     
                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={closePreviewModal} >Cancel</Button>                
                    <Button variant="success" type="submit" >Sign In</Button>                
                </Modal.Footer>   
            </Form>         
        </Modal>


        <Modal show={checkoutpreviewModal}>    
            <Form ref={formOutModal} onSubmit={SubmitCheckOut}>
                <Modal.Header>
                    <Modal.Title className="event-title" as="h5"> {agent.name} <br></br> Check Out & Complete </Modal.Title>
                    {/* <Modal.Title className="event-title" as="h5">Check Out & Complete</Modal.Title>                     */}
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Row className="g-4">

                            <Col xs="12">
                                <h6 className="overline-title">How did you help {clientName} today?</h6>                        
                            </Col>                   
                            
                            <Col xs="12">
                                <Form.Check className="form-check-md" name="completion_option_1" type="checkbox" id="completion_option_1" value="Medication" label="Medication"/>                        
                                <Form.Check className="form-check-md" name="completion_option_2" type="checkbox" id="completion_option_2" value="Food" label="Food"/>                        
                                <Form.Check className="form-check-md" name="completion_option_3" type="checkbox" id="completion_option_3" value="Drink" label="Drink"/>                        
                                <Form.Check className="form-check-md" name="completion_option_4" type="checkbox" id="completion_option_4" value="Personal Care" label="Personal Care"/>                        
                                <Form.Check className="form-check-md" name="completion_option_5" type="checkbox" id="completion_option_5" value="Toilet Assistance" label="Toilet Assistance"/>                        
                                <Form.Check className="form-check-md" name="completion_option_6" type="checkbox" id="completion_option_6" value="Housework" label="Housework"/>                        
                            </Col>                   
                            
                            <Col xs="12">
                                <h6 className="overline-title">Check Out Date & Time</h6>                        
                            </Col>                   
                            
                            <Col xs="4">                        
                                <DatePicker id="checkOutDate" name="checkOutDate" value={currentDate} placeholder="yyyy-mm-dd" />                        
                            </Col>
                            
                            <Col xs="3">                                                
                                <TimePicker id="checkOutTime" name="checkOutTime" value={toTimeOnly(currentDate)} placeholder="hh:mm"/>                    
                            </Col>                     

                            <Col xs="12">
                                <h6 className="overline-title">Notes</h6>                        
                            </Col> 
                            <Col xs="12">
                            <Form.Control id="completion_notes" name="completion_notes" as="textarea" placeholder="Notes" defaultValue={""}  />
                            </Col> 

                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={closecheckoutpreviewModal} >Cancel</Button>                
                    <Button variant="success" type="submit" >Sign Out</Button>                
                </Modal.Footer>   
            </Form>         
        </Modal>


    </>
  )
}

export default JobsheetCarerCheckInOut